import * as React from "react";
import { useNavigate } from "react-router-dom";

interface MapWheelPrope {
  onClose: () => void;
}

const MapWheelCMX: React.FC<MapWheelPrope> = ({ onClose }) => {
  const navigate = useNavigate();
  const [wheelVisible, setWheelVisible] = React.useState(false);

  React.useEffect(() => {
    setWheelVisible(true);
  }, []);

  function closeWheel() {
    setWheelVisible(false);
    setTimeout(() => {
      onClose();
    }, 500);
  }

  return (
    <>
      <div
        className={
          "transition-all duration-500 z-modal-level-3 relative " +
          (wheelVisible
            ? "opacity-1 pointer-events-auto"
            : "opacity-0 pointer-events-none")
        }
      >
        <div
          className="fixed top-0 left-0 w-full h-full"
          onClick={closeWheel}
          style={{
            backgroundImage: "radial-gradient(circle, white, #ffffff30)",
          }}
        ></div>

        <img
          src="/static/ls/images/cmx-wheel/background_x/background.png"
          className="w-[60rem] h-[60rem] fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        />

        <div className="flex flex-col -mt-[20px] items-center fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-modal-level-3">
          <img
            src="/static/ls/images/cmx-wheel/shield/shield.png"
            className="h-[10rem]"
          />
          <img
            src="/static/ls/images/cmx-wheel/shield/CMX.png"
            className="w-[22rem] -mt-[2rem]"
          />
        </div>

        <div className="fixed w-[40rem] h-[40rem] overflow-visible top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-modal-level-3">
          <svg className="w-full h-full absolute overflow-visible top-0 left-0 z-0">
            <circle
              cx="20rem"
              cy="20rem"
              r="23rem"
              // stroke="#e9ebec"
              stroke="#00000080"
              strokeWidth="3"
              fill="none"
              strokeLinecap="round"
              strokeDasharray="1, 20"
              className="animate-wheel_spin_reverse opacity-50 origin-center"
            />
            <circle
              cx="20rem"
              cy="20rem"
              r="27rem"
              // stroke="#e9ebec"
              stroke="#00000060"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeDasharray="1, 20"
              className="animate-wheel_spin origin-center"
            />
          </svg>

          <div className="w-[40rem] h-[40rem] absolute top-0 left-0 z-10">
            <img
              src="/static/ls/images/cmx-wheel/text-elements/AI_Normal.png"
              onClick={() => window.open("/ai-engine/", "_blank")}
              className="w-[20rem] h-[20rem] absolute bottom-0 right-0 scale-[0.95] cursor-pointer origin-bottom-right"
            />

            <img
              src="/static/ls/images/cmx-wheel/text-elements/shadow360.png"
              onClick={() => window.open("/shadow360", "_blank")}
              className="w-[20rem] h-[20rem] absolute bottom-0 left-0 scale-[0.95] cursor-pointer origin-bottom-left"
            />

            <img
              src="/static/ls/images/cmx-wheel/text-elements/liveshadow.png"
              onClick={() => {
                closeWheel();
                navigate("/");
              }}
              className="w-[20rem] h-[20rem] absolute top-0 left-0 scale-[0.95] cursor-pointer origin-top-left"
            />

            <img
              src="/static/ls/images/cmx-wheel/text-elements/integration.png"
              onClick={() => window.open("/plugins-store/", "_blank")}
              className="w-[20rem] h-[20rem] absolute top-0 right-0 scale-[0.95] cursor-pointer origin-top-right"
            />

            <div className="absolute top-1/2 left-1/2 scale-[0.7] -translate-x-1/2 -translate-y-1/2 w-[41rem] h-[41rem] rounded-full">
              <img
                src="/static/ls/images/cmx-wheel/rotating-wheel/wheel_animation.png"
                className="w-full h-full origin-center animate-wheel_spin rounded-full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MapWheelCMX;
